// == Imports NPM
import React from "react";
// == Import components
import Display from "../Display";
import NavBar from "../NavBar";

const Home = () => {

  return (
    <div className="main">
      <NavBar />
      <Display/>
    </div>
  )
};

export default Home;

